import PropTypes from 'prop-types';
import React from 'react';

import IconBounds from '../IconBounds';
import { Upload } from '../shapes';


const UploadSvg = (props) => (
  <g>
    <IconBounds />
    <Upload {...props} />
  </g>
);

UploadSvg.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};

UploadSvg.defaultProps = {
  fill: '#000',
  stroke: '#000',
  strokeWidth: 1,
};


export default UploadSvg;
